import { render, staticRenderFns } from "./NewReplyComposer.vue?vue&type=template&id=73c5d14c&scoped=true&"
import script from "./NewReplyComposer.vue?vue&type=script&lang=js&"
export * from "./NewReplyComposer.vue?vue&type=script&lang=js&"
import style0 from "./NewReplyComposer.vue?vue&type=style&index=0&id=73c5d14c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c5d14c",
  null
  
)

export default component.exports